import React from 'react';
import { useTranslation } from 'react-i18next';
import { CategorizationTypes } from '../../../enums';
import { trackMixPanel } from '../../../../../services/mixpanel.service';

const STYLES = {
  BASE: 'w-[97px] pb-[12px] text-center text-sm leading-5',
  ACTIVE: 'font-metricRSemibold text-action05 border-b-[3px] border-action03 cursor-default',
  INACTIVE: 'font-metricR text-bw07 border-b-[1px] border-bw07 cursor-pointer',
};

interface ICatTypeSwitcherProps {
  activeCatType: CategorizationTypes.expense | CategorizationTypes.income;
  onClick: (categorizationType: CategorizationTypes.expense | CategorizationTypes.income) => void;
  numOfExpenses: number;
  numOfIncome: number;
  isDisabled: boolean;
}
export const CategorizationTypeSwitcher = ({
  activeCatType,
  onClick,
  numOfExpenses,
  numOfIncome,
  isDisabled,
}: ICatTypeSwitcherProps) => {
  const { t } = useTranslation();
  const isExpenseActive = activeCatType === CategorizationTypes.expense;
  const handleExpenseTabClick = () => {
    if (!isDisabled && numOfExpenses > 0) onClick(CategorizationTypes.expense);
    trackMixPanel('Act on Expenses Tab - Categorization');
  };
  const handleIncomeTabClick = () => {
    if (!isDisabled && numOfIncome > 0) onClick(CategorizationTypes.income);
    trackMixPanel('Act on Income Tab - Categorization');
  };
  return (
    <div className='relative z-30 my-[20px] flex w-[194px] justify-center'>
      <div
        className={`${STYLES.BASE} ${isExpenseActive ? STYLES.ACTIVE : STYLES.INACTIVE}`}
        onClick={handleExpenseTabClick}
        role='button'
        tabIndex={0}
        onKeyDown={() => {}}
        data-testid='categorizationTypeSwitcher__expense'
      >
        {t('CATEGORIZATION_MAIN_VIEW.EXPENSES')}
        <span className='font-metricR ml-[3px]'>
          (
          {numOfExpenses}
          )
        </span>
      </div>
      <div
        className={`${STYLES.BASE} ${!isExpenseActive ? STYLES.ACTIVE : STYLES.INACTIVE}`}
        onClick={handleIncomeTabClick}
        role='button'
        tabIndex={0}
        onKeyDown={() => {}}
        data-testid='categorizationTypeSwitcher__income'
      >
        {t('CATEGORIZATION_MAIN_VIEW.INCOME')}
        <span className='font-metricR ml-[3px]'>
          (
          {numOfIncome}
          )
        </span>
      </div>
    </div>
  );
};
